import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, AlertCircle } from 'lucide-react';
const FadeIn = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.6,
  delay
}} data-id="element-10">
    {children}
  </motion.div>;
export function ArticleBody() {
  return <article className="max-w-2xl mx-auto px-4 font-sans text-gray-800 text-lg leading-relaxed space-y-10" data-id="element-11">
      <FadeIn data-id="element-12">
        <p className="drop-cap" data-id="element-13">
          Lo que estoy a punto de revelarte va en contra de todo lo que las
          grandes marcas de cosméticos no quieren que sepas. Durante años, nos
          han vendido la idea de que la única forma de combatir el
          envejecimiento es a través de cremas costosas, sueros milagrosos o
          procedimientos invasivos que paralizan nuestra expresión.
        </p>
        <p className="mt-6" data-id="element-14">
          Como especialista en medicina estética con más de 15 años de
          experiencia, he visto a miles de mujeres gastar fortunas en
          tratamientos que, en el mejor de los casos, ofrecen resultados
          temporales. Pero la verdad científica sobre el envejecimiento facial
          es mucho más profunda, literalmente.
        </p>
      </FadeIn>

      <FadeIn data-id="element-15">
        <div className="my-12 relative" data-id="element-16">
          <div className="absolute left-0 top-0 bottom-0 w-px bg-gold/50" data-id="element-17"></div>
          <h2 className="font-serif text-2xl sm:text-3xl text-burgundy font-semibold mb-6 pl-6" data-id="element-18">
            El Secreto Que La Industria Oculta
          </h2>
          <p className="pl-6 mb-6" data-id="element-19">
            La razón por la que tu piel parece "caerse" después de los 40 no es
            solo por la pérdida de colágeno. Es por la{' '}
            <strong data-id="element-20">atrofia muscular</strong>. Tu rostro tiene 57 músculos, y al
            igual que tu cuerpo, si no los ejercitas, pierden tono y volumen.
          </p>
          <ul className="space-y-5 pl-6" data-id="element-21">
            {['Las cremas solo tratan la superficie (epidermis), ignorando la estructura muscular que sostiene tu rostro.', 'Los procedimientos como el Botox paralizan el músculo, acelerando su atrofia a largo plazo.', 'La industria cosmética (valorada en miles de millones) depende de que compres sus productos mes tras mes.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-22">
                <AlertCircle className="w-5 h-5 text-gold shrink-0 mt-1" strokeWidth={2} data-id="element-23" />
                <span className="text-gray-700" data-id="element-24">{item}</span>
              </li>)}
          </ul>
        </div>
      </FadeIn>

      <FadeIn data-id="element-25">
        <h2 className="font-serif text-2xl sm:text-3xl text-gray-900 font-semibold mb-6" data-id="element-26">
          El Descubrimiento Japonés
        </h2>
        <p className="mb-6" data-id="element-27">
          Durante una conferencia en Kioto, descubrí un método ancestral que las
          mujeres japonesas han utilizado durante siglos para mantener una
          apariencia juvenil sin intervenciones. No se trata de un producto,
          sino de una técnica de reactivación neuromuscular.
        </p>
        <p className="mb-6" data-id="element-28">
          Estudios publicados en revistas dermatológicas recientes han comenzado
          a validar lo que la tradición oriental ya sabía: mediante movimientos
          específicos y controlados, es posible "despertar" los músculos
          faciales inactivos.
        </p>
        <div className="bg-white border border-gold/20 p-6 sm:p-8 rounded-sm shadow-sm my-8" data-id="element-29">
          <h3 className="font-serif text-xl text-burgundy mb-4 flex items-center gap-2" data-id="element-30">
            <Sparkles className="w-5 h-5 text-gold" data-id="element-31" />
            El Efecto "Lifting Natural"
          </h3>
          <p className="text-gray-600 text-base" data-id="element-32">
            Al tonificar la musculatura profunda, la piel adherida a ella se
            tensa naturalmente. El resultado es una elevación visible de los
            pómulos, reducción de la papada y una mirada más abierta. Todo esto
            dedicando apenas unos minutos al día, reactivando la circulación y
            estimulando la producción natural de colágeno desde adentro hacia
            afuera.
          </p>
        </div>
      </FadeIn>
    </article>;
}